<script>
import moment from "@/utils/moment";
import IconTooltip from "@/components/_Shared/Users/Status/IconTooltip";
import professionalRegisterFlowMixin from "@/mixins/professionalRegisterFlowMixin";
import OutOfCoverage from "./Steps/OutOfCoverage";
import Created from "./Steps/Created";
import DocumentValidation from "./Steps/DocumentValidation";
import BackgroundCheckValidation from "./Steps/BackgroundCheckValidation";
import AccessDenied from "./Steps/AccessDenied";
import PGA from "./Steps/PGA";
import Training from "./Steps/Training";
import CombateAFraudeLinks from "./CombateAFraudeLinks";

export default {
  mixins: [professionalRegisterFlowMixin],

  components: {
    OutOfCoverage,
    Created,
    DocumentValidation,
    BackgroundCheckValidation,
    AccessDenied,
    PGA,
    IconTooltip,
    Training,
    CombateAFraudeLinks
  },

  props: {
    professional: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      headers: [
        {
          text: "Etapa",
          value: "events",
          align: "center",
          sortable: false
        },
        {
          text: "Ultima atualização",
          value: "lastOccurency",
          align: "center",
          sortable: false
        },
        {
          value: "data-table-expand",
          align: "center"
        }
      ],
      events: []
    };
  },

  methods: {
    setProfessionalEvents() {
      this.events = this.buildEventsHistory(this.professional.events);
    },

    formattedDate(datetime) {
      return datetime.format("DD MMMM YYYY HH:mm:ss");
    }
  },

  mounted() {
    this.setProfessionalEvents();
  }
};
</script>

<template>
  <div>
    <CombateAFraudeLinks :professional="professional" />
    <Training :professionalId="professional.id" />

    <template>
      <v-data-table
        :headers="headers"
        :items="events"
        show-expand
        single-expand
        item-key="step"
      >
        <template v-slot:item.events="{ headers, item }">
          <IconTooltip
            :options="getStatus(eventName(item.events.slice(-1)[0].event_type))"
          />
          {{ eventName(item.events.slice(-1)[0].event_type) | getStatusName }}
        </template>

        <template v-slot:item.lastOccurency="{ headers, item }">
          {{ formattedDate(item.lastOccurency) }}
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <OutOfCoverage
              v-if="
                isOutOfRange(eventName(item.events.slice(-1)[0].event_type))
              "
              :professional="professional"
            />

            <Created
              v-if="
                isCreatedStep(eventName(item.events.slice(-1)[0].event_type))
              "
              :professional="professional"
            />

            <DocumentValidation
              v-if="
                isDocumentsValidationStep(
                  eventName(item.events.slice(-1)[0].event_type)
                )
              "
              :professional="professional"
              :events="item.events"
              @refresh="$emit('refresh')"
            />

            <BackgroundCheckValidation
              v-if="
                isBackgroundcheckValidationStep(
                  eventName(item.events.slice(-1)[0].event_type)
                )
              "
              :professional="professional"
              :events="item.events"
              @refresh="$emit('refresh')"
            />

            <PGA
              v-if="
                isPgaValidationStep(
                  eventName(item.events.slice(-1)[0].event_type)
                )
              "
              :professional="professional"
              :events="item.events"
              @refresh="$emit('refresh')"
            />

            <AccessDenied
              v-if="
                isAccessDeniedValidationStep(
                  eventName(item.events.slice(-1)[0].event_type)
                )
              "
              :professional="professional"
              :events="item.events"
            />
          </td>
        </template>
      </v-data-table>
    </template>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Register/Index.vue